export const PASSWORD_RESET_TOKEN = 'pwrt';

export const SEARCH = {
	CLIENT_ID: 'client_id',
	GIGYA_KEY: 'gigya_key',
	CLIENT_NAME: 'client_name',
	REDIRECT_URI: 'redirect_uri',
	STATE: 'state',
	PROMPT: 'prompt',
	USER_CODE: 'user_code',
	ID_TOKEN_HINT: 'id_token_hint',
	PASSWORD_RESET_TOKEN,
	CHANNEL: 'channel',
	STYLE_HINT: 'style_hint',
};

export const SEARCH_WHITELIST = Object.values(SEARCH);
